import { createRoutesFromElements, NavigateOptions, RouterProvider, To } from 'react-router';
import { createBrowserRouter } from 'react-router-dom';
import Routes from './Routes/Routes';

// https://reactrouter.com/api/hooks/useNavigate#return-type-augmentation
declare module 'react-router' {
    interface NavigateFunction {
        (to: To, options?: NavigateOptions): Promise<void>;
        (delta: number): Promise<void>;
    }
}

// Check this example for ideas: https://github.com/remix-run/react-router/blob/dev/examples/auth/src/App.tsx

const router = createBrowserRouter(
    createRoutesFromElements(
        Routes(),
    ),
);

function App(): React.ReactElement {
    return (
        <RouterProvider router={router} />
    );
}

export default App;
